import raw from "../data/colombia.json" with { type: "json" };
export const colombia = raw;
//# sourceMappingURL=data.js.map